import { render, staticRenderFns } from "./AutoComplete.vue?vue&type=template&id=36bf0ec9&scoped=true"
import script from "./AutoComplete.ts?vue&type=script&lang=ts&external"
export * from "./AutoComplete.ts?vue&type=script&lang=ts&external"
import style0 from "./AutoComplete.scss?vue&type=style&index=0&id=36bf0ec9&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bf0ec9",
  null
  
)

export default component.exports